import PosCartActions from '../../../actions/PosCartActions';
import UserStore from '../../../stores/UserStore';
import PosCartStore from '../../../stores/PosCartStore';

class Decrease extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        }

        this.decrease = this.decrease.bind(this);
        this.isItemInCart = this.isItemInCart.bind(this);
        this.onCartStoreChange = this.onCartStoreChange.bind(this);
    }

    componentDidMount() {
        this.setState({ 
            loading: PosCartStore.getState().loading
        });
        PosCartStore.addChangeListener(this.onCartStoreChange);
    }

    componentWillUnmount() {
        PosCartStore.removeChangeListener(this.onCartStoreChange);
    }

    onCartStoreChange() {
        this.setState({ 
            loading: PosCartStore.getState().loading
        });
    }

    decrease() {
        var item = this.isItemInCart();

        if (!item || this.state.loading)
            return;
        
        let qtyToRemove = this.props.item.WgtCnt == 'Qty' ? 1 : this.props.item.Grams;
        this.setState({ loading: true });
        PosCartActions.removeItemFromCart(this.props.item, this.props.guest, qtyToRemove, true);
    }

    isItemInCart() {
        var item    = this.props.item;
        var cart    = PosCartStore.getState().cart;

        if (!cart)
            return false;

        for (var i=0; i<cart.length; i++) {
            if (cart[i].SerialNo === item.SerialNo)
                return cart[i];
        }

        return false;
    }

    render() {
        var item        = this.props.item;
        var guest       = this.props.guest;
        var className   = !this.isItemInCart() || this.state.loading ? 'btn-green__disabled' : '';
        var selectedLocation = UserStore.getState().selectedLocation;

        if(this.props.hide) {
            return null;
        }

        if (guest.IsPaid) {
            return null;
        }

        return (
            <div className={'decrease '+(this.props.page === 'search' ? 'decrease__search' : '')}>

                <div
                    className={'decrease__btn '+className}
                    onClick={this.decrease}>
                    { this.state.loading ? <i className='fa fa-spinner fa-spin' aria-hidden='true' /> : <i className='fa fa-minus' aria-hidden='true' /> }
                    
                </div>
            </div>

        );
    }
}

export default Decrease;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/selected/Decrease.react.jsx